import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as serviceWorker from './serviceWorker';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import Particles from 'particlesjs';
import * as Sentry from '@sentry/browser';

Sentry.init({
  dsn:
    'https://700e82a57e0946e4bccee5132c0c7f8b@o310326.ingest.sentry.io/5209128',
});

let options = {
  autoConfig: true,
  debug: false,
};

if (process.env.NODE_ENV !== 'production') {
  options = {
    autoConfig: true,
    debug: true,
  };
}

ReactPixel.init('266895673774131', options);
ReactPixel.pageView();

ReactGA.initialize('UA-99762137-3', options);
ReactGA.pageview('/uquest');

AOS.init();

window.addEventListener('resize', function () {
  AOS.refreshHard();
});

ReactDOM.render(
  <React.StrictMode>
    <App />
    <canvas className="background" />
  </React.StrictMode>,
  document.getElementById('root'),
);

Particles.init({
  selector: '.background',
  color: ['#A9A9A9', '#072a33'],
  sizeVariations: 5,
  connectParticles: true,
  responsive: [
    {
      breakpoint: 768,
      options: {
        maxParticles: 200,
        color: '#48F2E3',
        connectParticles: true,
      },
    },
    {
      breakpoint: 425,
      options: {
        maxParticles: 30,
        connectParticles: true,
      },
    },
    {
      breakpoint: 320,
      options: {
        maxParticles: 0,
        // disables particles.js
      },
    },
  ],
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
